export default [
  {
    path: '/auditCenter',
    name: 'auditCenter',
    component: () => import('@/views/auditCenter/Index.vue'),
    meta: { title: '审核中心' }
  },
  {
    path: '/auditCenter',
    name: 'auditDetail',
    component: () => import('@/views/auditCenter/Detail.vue'),
    meta: { title: '审核详情' }
  }
]
